module.exports = __webpack_public_path__ + "media/images/athletes/3598-f731a58f14a05ca364f78b5bc70b9f78.png";